import React from "react";
import s from './ThisDay.module.scss'


export const ThisDay = ({data}: any) => {
    const weatherIconPath = `icons/${data.weather[0].icon}.png`
    return (
        <div className={s.this__day}>
            <div className={s.top__block}>
                <div className={s.top__block_wrapper}>
                    <div className={s.this__temp}>
                        {Math.round(data.main.temp)}°
                    </div>
                    <div className={s.this__day_name}>
                        Today
                    </div>
                </div>
                <img src= {weatherIconPath} alt='Current weather image'/>
            </div>
            <div className={s.bottom__block}>
                <div className={s.this__city}>
                    {data.city}
                </div>
                <div className={s.this__add_info}>
                    Feels like: {Math.round(data.main.feels_like)}°
                </div>
            </div>
        </div>
    )
}